<template>
  <div>
    <v-btn
      class="text-capitalize button-red-round"
      dark
      small
      @click="launchPasswordStep"
    >
      Cambiar password
    </v-btn>
  </div>
</template>

<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  import { mapActions } from 'vuex';

  export default {
    name: 'ChangePasswordControl',

    props: {
      isLarge: {},
    },

    data() {
      return {
        loading: false,
      };
    },

    methods: {
      ...mapActions('modalStepsAfterLogin', [
        'updateModalState',
        'findStepByKey',
        'changeCurrentStepValue',
        'updateStepStatus',
        'loadUpdatePasswordStep',
      ]),
      ...mapActions('updatePassword', ['setWantUpdatePassword']),

      async launchPasswordStep() {
        this.loading = true;
        try {
          this.setWantUpdatePassword(true);
          await this.loadUpdatePasswordStep();

          const updatePasswordStep = await this.findStepByKey('updatePassword');

          if (updatePasswordStep) {
            updatePasswordStep.visited = true;

            if (updatePasswordStep.doneRequired === true) {
              updatePasswordStep.doneRequired = false;
            }

            this.updateStepStatus(updatePasswordStep);
            this.changeCurrentStepValue(updatePasswordStep.value);
            this.updateModalState(true);
          }
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>
